import { useEffect, useRef, useState } from 'react';
import { useDebouncedEffect } from '../../CustomHooks';
import styles from './ExpandableGeneric.module.scss';

export type ExpandableProps = {
  isExpanded: boolean;
  children: React.ReactNode;
};

const ExpandableGeneric = ({ isExpanded, children }: ExpandableProps): JSX.Element => {
  const [contentHeight, setContentHeight] = useState('0px');

  const contentRef = useRef<HTMLDivElement>(null);

  const handleResize = () => {
    const newTextHeight = !isExpanded || contentRef.current === null ? `0px` : `${contentRef.current.scrollHeight}px`;
    setContentHeight(newTextHeight);
  };

  useDebouncedEffect(() => window.addEventListener('resize', handleResize), [handleResize], 1000);

  useEffect(() => {
    setContentHeight(!isExpanded || contentRef.current === null ? '0px' : `${contentRef.current.scrollHeight}px`);
  }, [children, isExpanded]);

  return (
    <div className={styles.accordionContainer}>
      <div className={styles.accordionText} ref={contentRef} style={{ maxHeight: `${contentHeight}` }}>
        {children}
      </div>
    </div>
  );
};

export default ExpandableGeneric;
